import Logo from '../logo.png';



const Header = () => {
    return (
        <header className="container flex justify-between pt-4 md:pt-10 w-full mb-2">
            <div className="max-h-14">
            <img src={Logo} alt="logo" className="h-full" />
            </div>
         <a href="mailto:info@qtsoftwareltd.com" target="_blank" className="flex items-center justify-center bg-transparent shadow py-2 text-white md:text-[18px] text-[12px] font-bold px-4 rounded-full max-h-10 md:w-auto w-[50vw] no-underline">
           Contact Us
          </a>
           
        </header>
    )
    }

    export default Header;
